// How many players to fetch/display on the live leaderboard.
// Allowed values: 10 (single page, no rotation), 20 or 30 (paginated, auto-rotating in pages of PAGE_SIZE).
// Currently hardcoded below - change NUMBER_OF_PLAYERS to adjust.
export const NUMBER_OF_PLAYERS = 20;

// How often the leaderboard refetches results, in ms.
// Page rotation uses the same interval so it stays in sync with data refreshes.
export const REFRESH_INTERVAL_MS = 7000;

export const PAGE_SIZE = 10;
